import Heading from "components/Heading";
import React, { useState } from "react";
import { Link, useNavigate } from 'react-router-dom';
import {
  Button, Col, Container, Row, Table, UncontrolledDropdown,
  DropdownToggle, DropdownMenu, DropdownItem
} from "reactstrap";
import { errorHandler, toLocaleTime } from "utils/Api";
import styles from "./style.module.scss";
import { ThreeDotsVertical } from 'react-bootstrap-icons';
import { deletePackage, getPackages, savePackage } from "api/PackagesApi";
import LoadingTBody from "components/LoadingTBody";
import { showAlert } from "utils/Alert";
import DeleteModal from "components/DeleteModal";
import AddWarehouseModal from "components/AddWarehouseModal";
import PackageCostDetails from "components/OffCanvas/PackageCostDetailsOffCanvas";
import { useAmplifyIncrementalList } from "utils/hooks/useAmplifyIncrementalList";
import { debounce } from "lodash";
import DynamicForm from "components/DynamicForm";
import ConfirmModal from "components/ConfirmModal";
import { getPackageStatus } from "utils/Utils";

const PAGE_SIZE_LIMIT = 100

const Packages = props => {
  let navigate = useNavigate();
  const [typeAheadFilter, setTypeAheadFilter] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isDeleteConfirmVisible, setDeleteConfirmVisible] = useState(false);
  const [isDeliveryConfirmVisible, setDeliveryConfirmVisible] = useState(false);
  const [toUpdateBox, setToUpdateBox] = useState({});
  const [isModalOpen, setIsModalOpen] = useState(true);
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);

  const buildPackagesFilter = (filter) => {
    const q = (filter || "").trim();
    if (!q) return null;

    return {
      or: [
        { client: { contains: q } },
        { secuencia: { contains: q } },
        { tracking_num: { contains: q } },
        { warehouseNumber: { eq: q } },
      ],
    };
  };

  const {
    items: boxesList,
    isLoadingInitial,
    isLoadingMore,
    isSearching,
    reload: reloadView,
    bottomRef,
  } = useAmplifyIncrementalList({
    fetchPage: getPackages,
    searchText: typeAheadFilter,
    buildFilter: buildPackagesFilter,
    pageSize: PAGE_SIZE_LIMIT,
  });

  const showLoading = isLoadingInitial || isLoadingMore || isSearching || isLoading;

  const renderList = () => {
    return boxesList.map((box) => {
      let created = toLocaleTime(box.createdAt);
      return (
        <tr key={box.id}>
          <td>
            {box.secuencia}
          </td>
          <td>
            {box.warehouseNumber}
          </td>
          <td>
            <Link to={`/admin/packagesByPoBox/${box.poBoxBoxesId}`}>
              {box.client}
            </Link>
          </td>
          <td>
            {created}
          </td>
          <td>
            {box.cargoMovement && box.cargoMovement.secuencia}
          </td>
          <td>
            {getPackageStatus(box)}
          </td>
          <td>
            <PackageCostDetails box={box} color="primary" />
          </td>
          <td>
            {rowActions(box)}
          </td>
        </tr>
      );
    });
  }

  const deleteBox = (box) => {
    setIsLoading(true);
    deletePackage(box)
      .then(async (r) => {
        showAlert("success", `El Paquete #${box.secuencia} fue eliminado correctamente`);
        toogleModal();
      }).catch(e => {
        errorHandler(e);
        showAlert("danger", `No fue posible eliminar el paquete #${box.secuencia}`);
      })
      .finally(() => {
        setIsLoading(false);
        reloadView()
      });
  }

  const showDeleteConfirm = (box) => {
    setDeleteConfirmVisible(true)
    setToUpdateBox(box);
    setIsModalOpen(true);
  }

  const showDeliveryConfirm = (box) => {
    setDeliveryConfirmVisible(true)
    setToUpdateBox(box);
    setIsModalOpen(true);
  }

  const toogleModal = (e) => {
    setIsModalOpen(!isModalOpen);
    if (isModalOpen) {
      setToUpdateBox({});
      setDeliveryConfirmVisible(false)
      setDeleteConfirmVisible(false)
    }
  }

  const rowActions = (box) => {
    return (
      <UncontrolledDropdown>
        <DropdownToggle tag="span" className={styles.threedotsBtn} >
          <ThreeDotsVertical size="1.5rem" />
        </DropdownToggle>
        <DropdownMenu container="body">
          <DropdownItem header>
            Acciones
          </DropdownItem>
          <DropdownItem onClick={(e) => { navigate(`/admin/package/edit/${box.id}`) }}>
            Editar Paquete
          </DropdownItem>
          <DropdownItem onClick={(e) => { navigate(`/admin/package/cost/${box.id}`) }}>
            Editar Costo de Paquete
          </DropdownItem>
          {box.cargoMovement && box.cargoMovement.id && (
            <DropdownItem onClick={(e) => { navigate(`/admin/cargo-movement/edit/${box.cargoMovement.id}`) }}>
              Editar Movimiento de Carga
            </DropdownItem>
          )}
          <DropdownItem onClick={(e) => showDeleteConfirm(box)}>
            Eliminar Paquete
          </DropdownItem>
          {!box.isDelivered && (
            <DropdownItem onClick={(e) => showDeliveryConfirm(box)}>
              Marcar Paquete Como Entregado
            </DropdownItem>
          )}
        </DropdownMenu>
      </UncontrolledDropdown>
    );
  }

  const toogleAddModal = (e) => {
    setIsAddModalOpen(!isAddModalOpen);
  }

  const getSearchForm = () => {
    return {
      sections: [{
        fields: [
          [
            {
              "type": "text",
              "name": "q",
              "label": "Filtro",
              "disabled": false,
              "sizing": {
                "sm": 6
              }
            },
          ]
        ]
      }]
    };
  }

  const typeAHeadSearch = debounce((search) => {
    setTypeAheadFilter(search);
  }, 500)

  const onDeliveryConfirmed = async () => {
    const boxData = {
      id: toUpdateBox.id,
      isDelivered: true,
    }
    try {
      setIsLoading(true)
      debugger
      await savePackage(boxData);
      showAlert("success", "El paquete ha sido marcado como Entregado")
      reloadView()
    } catch (err) {
      debugger
      showAlert("danger", "No fue posible marca el paquete como Entregado.")
    } finally {
      setIsLoading(false)
      toogleModal()
    }
  }

  return (
    <>
      <AddWarehouseModal
        toggle={toogleAddModal}
        isOpen={isAddModalOpen}
      />
      <Heading headingLevel="h2" className="pt-4" label="Lista de Warehouse" sticky >
        <Col sm={2}>
          <Button
            className="float-end"
            color="success"
            onClick={(e) => toogleAddModal()}
          > Agregar Warehouse</Button>
        </Col>
      </Heading>
      <DynamicForm
        id="search"
        formConfig={getSearchForm()}
        onInputChange={(fieldName, v) => typeAHeadSearch(v)}>

      </DynamicForm>
      <Container>
        <Row>
          <Col>
            <Table hover>
              <thead>
                <tr>
                  <th>
                    #
                  </th>
                  <th>
                    Warehouse
                  </th>
                  <th>
                    Cliente
                  </th>
                  <th>
                    Fecha Ingreso
                  </th>
                  <th>
                    # Carga
                  </th>
                  <th>
                    Estado
                  </th>
                  <th>
                    Costo
                  </th>
                  <th width="2%"></th>
                </tr>
              </thead>
              <LoadingTBody aheadLoading extraColumns={false} isLoading={showLoading}>
                {renderList()}
                {
                  boxesList.length == 0 && typeAheadFilter && !showLoading && (
                    <tr>
                      <td colSpan="20">
                        <b>No se encontro ningun resultado con el filtro ingresado</b>
                      </td>
                    </tr>
                  )
                }
                <tr>
                  <td colSpan="20">
                    <div ref={bottomRef} style={{ height: 1 }} />
                  </td>
                </tr>
              </LoadingTBody>
            </Table>
            {toUpdateBox && toUpdateBox.id && isDeleteConfirmVisible && (
              <DeleteModal
                title="Eliminar Paquete"
                toogle={toogleModal}
                isOpen={isModalOpen}
                onDelete={() => { deleteBox(toUpdateBox) }}>
                Esta seguro que desea eliminar el paquete #{toUpdateBox.secuencia}?
              </DeleteModal>
            )}
            {toUpdateBox && toUpdateBox.id && isDeliveryConfirmVisible && (
              <ConfirmModal
                toggle={toogleModal}
                isOpen={isModalOpen}
                title="Confirma Entrega"
                onConfirm={onDeliveryConfirmed}
                primaryBtn="Entregar"
              >
                Esta seguro que desea marcar este paquete como entregado?
              </ConfirmModal>
            )}
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default Packages;
